import messages from './messages';

export const errorFlag = () => ({
	type: 'error',
	...messages,
});
